<!-- @format -->

<section id="attributes-v2-container">
	@if (!colorSelectionPanelEnabled() && !disableSkuLevelPricing()) {
		@for (colorAttributeBucket of colorAttributeBuckets(); track $index) {
			<div
				id="attr_{{ colorAttributeBucket.bucket.defAttributes.name }}{{ $index }}"
				[ngClass]="{
					'hmf-mb-m hmf-mb-md-l hmf-pb-0': colorAttributeBuckets()?.length > 1
				}">
				<div class="hmf-display-flex hmf-flex-wrap">
					@if (colorAttributeBuckets().length > 1) {
						<div class="color-split-price">
							<pdp-price
								[index]="$index"
								[selectedBucketIndex]="selectedBucketIndex"
								[bucket]="colorAttributeBucket"></pdp-price>
						</div>
					}
				</div>
				<div class="color-container">
					<pdp-attributes-components-label
						[attributeGroupName]="'Color'"
						[index]="$index + 1"
						[selectedBucketIndex]="selectedBucketIndex"
						[bucket]="colorAttributeBucket">
					</pdp-attributes-components-label>
					<div>
						<pdp-attributes-components-color-selection
							[colorAttributeData]="
								colorAttributeBucket.bucket.defAttributes.property
							"
							(selectedAttributeOnClick)="selectedAttributeOnClick($event)"
							[isColorBucket]="true"
							[alternativeInStockIsShowing]="
								shouldShowAlternativeInStockRecs && alternativeInStockRecsEnabled()
							"
							[isMobile]="isMobile()"
							[lazyLoadImages]="isMobile()">
						</pdp-attributes-components-color-selection>

						<!-- Check if there are colorAttributeBuckets. If so, only render this element below the bottom color bucket. Otherwise, bypass this condition with "true" since there are no buckets -->
						@if (
							(shouldShowAlert$ | async) &&
							(!!product?.colorAttributeBuckets.length
								? $index === product?.colorAttributeBuckets.length - 1
								: true) &&
							chain.chainIdentifierAbbr === 'g3'
						) {
							<div class="low-stock-alert-container">
								<img
									src="assets/image/g3/Low_Stock.svg"
									class="low-stock-alert-icon"
									alt="low stock alert icon" />
								<h2 class="low-stock-alert-text hmf-subheader-bold-l">
									Hurry, Almost Gone!
								</h2>
							</div>
						}
					</div>
				</div>
			</div>
		}
	}

	@if ({ attributes: attributes$ | async }; as vm) {
		@if (
			(dropdownAttributesEnabled() && vm.attributes.length <= 3) ||
			!dropdownAttributesEnabled()
		) {
			@for (attributeGroup of vm.attributes; track $index) {
				<div [ngClass]="{ 'hmf-mb-m hmf-mb-md-l': !$last }">
					@if (
						attributeGroup[0]?.name.toLowerCase() === 'color' &&
						(disableSkuLevelPricing() || colorSelectionPanelEnabled())
					) {
						@if (disableSkuLevelPricing() && !colorSelectionPanelEnabled()) {
							<pdp-attributes-components-color-selection
								[colorAttributeData]="attributeGroup"
								[isColorBucket]="false"
								[alternativeInStockIsShowing]="
									shouldShowAlternativeInStockRecs &&
									alternativeInStockRecsEnabled()
								"
								(selectedAttributeOnClick)="selectedAttributeOnClick($event)"
								[isMobile]="isMobile()"
								[lazyLoadImages]="isMobile()"></pdp-attributes-components-color-selection>
						}
						@if (colorSelectionPanelEnabled()) {
							<pdp-attributes-components-color-attribute-panel
								[colorAttributeData]="attributeGroup"
								(selectedAttributeOnClick)="selectedAttributeOnClick($event)"
								[colorQueryParam]="colorQueryParam"
								[skuQueryParam]="
									skuIdQueryParam()
								"></pdp-attributes-components-color-attribute-panel>
						}
						@if ((shouldShowAlert$ | async) && chain.chainIdentifierAbbr === 'g3') {
							<div class="low-stock-alert-container">
								<img
									src="assets/image/g3/Low_Stock.svg"
									class="low-stock-alert-icon"
									alt="low stock alert icon" />
								<h2 class="low-stock-alert-text hmf-subheader-bold-l">
									Hurry, Almost Gone!
								</h2>
							</div>
						}
					}
					@if (attributeGroup[0]?.name?.toLowerCase() === 'text color') {
						<pdp-attributes-components-text-color-selection
							[labelAttrGroupName]="attributeGroup[0]?.name"
							[selectorAttributeData]="attributeGroup"
							(selectedAttributeOnClick)="selectedAttributeOnClick($event)">
						</pdp-attributes-components-text-color-selection>
					}
					@if (
						attributeGroup[0]?.name.toLowerCase() !== 'color' &&
						attributeGroup[0]?.name?.toLowerCase() !== 'text color'
					) {
						<div
							[ngClass]="{
								'hmf-mb-m':
									truefitEnabled() &&
									sizeSelectionPanelEnabled() &&
									attributeGroup[0]?.name.toLowerCase().includes('size')
							}">
							@if (
								!sizeSelectionPanelEnabled() ||
								!attributeGroup[0]?.name.toLowerCase().includes('size')
							) {
								<pdp-attributes-components-default-attribute-selection
									[labelAttrGroupName]="attributeGroup[0]?.name"
									[selectorAttributeData]="attributeGroup"
									[alternativeInStockIsShowing]="
										shouldShowAlternativeInStockRecs &&
										alternativeInStockRecsEnabled()
									"
									[isAlternativeInStockEnabled]="
										this.alternativeInStockRecsEnabled() &&
										this.isApparelOrFootwear()
									"
									(selectedAttributeOnClick)="selectedAttributeOnClick($event)">
								</pdp-attributes-components-default-attribute-selection>
							} @else {
								<pdp-attributes-components-size-selection-panel
									[sizeAttributeData]="attributeGroup"
									(selectedAttributeOnClick)="selectedAttributeOnClick($event)">
								</pdp-attributes-components-size-selection-panel>
							}
						</div>

						@if (attributeGroup[0]?.name === sizeChartAttribute()) {
							<!-- Move size chart to the end of the row if there is no true fit (using hmf-flex-row-reverse) -->
							<div
								class="hmf-display-flex hmf-flex-row hmf-justify-content-between hmf-mb-s"
								[ngClass]="{ 'hmf-flex-row-reverse': !truefitEnabled() }">
								@if (truefitEnabled()) {
									<div class="true-fit">
										<div
											class="tfc-fitrec-product"
											[attr.data-colorid]="trueFitSelectedColor"
											[attr.data-styleid]="product.partNumber"
											data-userid="userId"></div>
									</div>
								}

								<!-- Size Chart -->
								@if (product?.sizeChart) {
									<div class="hmf-pr-0">
										<pdp-component-size-chart-v2
											[sizeChartName]="
												product.sizeChart
											"></pdp-component-size-chart-v2>
									</div>
								}
							</div>
						}
					}
					<!-- Alternative In Stock -->
					@if (displayAlternativeInStock(attributeGroup[0], $last)) {
						<div class="hmf-my-m">
							<hmf-alert-banner
								type="warn"
								[title]="'Option Not Available'"></hmf-alert-banner>
						</div>
						<shared-components-product-recommendations
							class="full-width"
							[displayName]="'Try Similar in Your Size'"
							[schemes]="'schemes'"
							[filterBy]="'skuoos2_rr'"
							[showViewMoreLink]="false"
							[isOOSRecommendations]="false"
							[isAlternativeInStock]="true"
							[showSkeletonLoading]="
								isLoadingStateRecsEnabled()
							"></shared-components-product-recommendations>
					}
				</div>
			}
		} @else {
			<pdp-attributes-components-config-attributes-panel
				[customSeoUrl]="customSeoUrl()"
				(attributesSelected)="onConfigPanelAttributesSelected($event)">
			</pdp-attributes-components-config-attributes-panel>
		}
	}

	@if (!sizeChartAttribute() && product?.sizeChart) {
		<div class="hmf-display-flex hmf-flex-row-reverse hmf-justify-content-between hmf-mb-s">
			<pdp-component-size-chart-v2
				[sizeChartName]="product.sizeChart"></pdp-component-size-chart-v2>
		</div>
	}

	@if (isPersonalizationProduct) {
		<pdp-attributes-components-personalization [product]="product">
		</pdp-attributes-components-personalization>
	}
</section>
